import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Table, Button, Nav, Modal, Form } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { jwtDecode } from "jwt-decode";
import './AdminDashboard.css';

const AdminDashboard = () => {

  const [activeTab, setActiveTab] = useState('arizona');
  const [showModal, setShowModal] = useState(false);
  const [properties, setProperties] = useState([]);
  const [adminEmail, setAdminEmail] = useState('');
  const [recentLogs, setRecentLogs] = useState([]);
  
  const token = localStorage.getItem('adminToken');
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('adminToken');
    if (!token) {
      navigate('/admin-portal-access'); // Return to login if there is no token
    } else {
      try {
        // 1. Decode email from token
        const decoded = jwtDecode(token);
        setAdminEmail(decoded.email);

        // 2. Load the logs from the server
        fetchLogs(token);
      } catch (error) {
        console.error("Token error:", error);
        navigate('/admin-portal-access');
      }
    }
  }, [navigate]);

  // Function for getting logs
  const fetchLogs = async (authToken) => {
    try {
      //const response = await fetch('http://localhost:5000/api/admin/logs', {
      const response = await fetch('/api/admin/logs', {
        headers: { 'Authorization': authToken }
      });
      if (response.ok) {
        const data = await response.json();
        setRecentLogs(data.slice(0, 5)); // Getting the lastest 5 logs
      }
    } catch (error) {
      console.error("Error fetching logs:", error);
    }
  };

  // View & Edit States
  const [showViewModal, setShowViewModal] = useState(false);
  const [selectedProperty, setSelectedProperty] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);
  const [currentEditFolder, setCurrentEditFolder] = useState('');

  const [newProperty, setNewProperty] = useState({
    title: '',
    location: '',
    googleMaps: '',
    directLink: '',
    isAvailable: true,
    overview: '',
    amenities: [],
    amazingFeatures: [],
    images: null
  });

  const amenitiesList = [
    "Swimming pool", "Indoor gym", "Club house", "Indoor full-sized basketball cort", "On premises bar & gril",
    "Availabe maintenance", "Fully stocked appliances", "Private driveway", "Private garage", "Safe neighborhood",
    "Warm weather", "Large backyard", "Full size backetball hoop"
  ];

  const amazingFeaturesList = [
    "Granite coutertops", "Laminate/Tile flooring", "Screen in patio", "24/7 Security on premises",
    "Gated community", "Fresh carpet", "Patio", "Secure entry", "Safe community",
    "Tile flooring", "Backyard", "In-ground pool", "Fenced in yard"
  ];

  const fetchProperties = async () => {
    try {
      const token = localStorage.getItem('adminToken');
      
      //const response = await fetch(`http://localhost:5000/api/properties/${activeTab}`, {
      const response = await fetch(`/api/properties/${activeTab}`, {
        headers: {
          'Authorization': token
        }
      });
      
      if (response.ok) {
        const data = await response.json();
        setProperties(data);
      }
    } catch (error) { 
      console.error("Error fetching data:", error); 
    }
  };

  useEffect(() => { fetchProperties(); }, [activeTab]);

  // --- HANDLERS ---
  const handleClose = () => {
    setShowModal(false);
    setIsEditMode(false);
    setNewProperty({ title: '', location: '', googleMaps: '', overview: '', amenities: [], amazingFeatures: [], images: null });
  };

  const handleShow = () => {
    setIsEditMode(false);
    setShowModal(true);
  };

  // This must be identical to the one on the server
  const getFolderSlug = (title) => {
    return title.toLowerCase()
      .replace(/[^a-z0-9]+/g, '-') // Changes everything that is not a character/number to a slash
      .replace(/(^-|-$)/g, '');    // Removes slash on the start and end
  };

  const handleEditOpen = (prop) => {
    setIsEditMode(true);
    setCurrentEditFolder(getFolderSlug(prop.title)); 
    
    setNewProperty({
      title: prop.title,
      location: prop.location,
      googleMaps: prop.googleMaps || '',
      directLink: prop.directLink || '',
      isAvailable: prop.isAvailable !== undefined ? prop.isAvailable : true,
      overview: prop.overview,
      amenities: prop.amenities || [],
      amazingFeatures: prop.amazingFeatures || [],
      images: prop.images || []
    });
    setShowModal(true);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setNewProperty({ ...newProperty, [name]: value });
  };

  // Universal handler ofr both checkbox rows
  const handleCheckboxChange = (field, item) => {
    const currentList = newProperty[field];
    const updatedList = currentList.includes(item)
      ? currentList.filter(i => i !== item)
      : [...currentList, item];
    setNewProperty({ ...newProperty, [field]: updatedList });
  };

  const removeExistingImage = (imgIndex) => {
    const updatedImages = newProperty.images.filter((_, index) => index !== imgIndex);
    setNewProperty({ ...newProperty, images: updatedImages });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append('title', newProperty.title);
    formData.append('location', newProperty.location);
    formData.append('googleMaps', newProperty.googleMaps);
    formData.append('directLink', newProperty.directLink);
    formData.append('isAvailable', newProperty.isAvailable);
    formData.append('overview', newProperty.overview);
    formData.append('activeTab', activeTab);
    formData.append('amenities', JSON.stringify(newProperty.amenities));
    formData.append('amazingFeatures', JSON.stringify(newProperty.amazingFeatures));

    if (isEditMode) {
      // EDIT MOD
      formData.append('existingImages', JSON.stringify(newProperty.images)); // Pictures that are left
      if (newProperty.newImages) { // New pictures that we add
        for (let i = 0; i < newProperty.newImages.length; i++) {
          formData.append('images', newProperty.newImages[i]);
        }
      }

      
      try {
        //const response = await fetch(`http://localhost:5000/api/properties/${activeTab}/${currentEditFolder}`, {
        const response = await fetch(`/api/properties/${activeTab}/${currentEditFolder}`, {
          method: 'PUT',
          headers: {
            'Authorization': token,
          },
          body: formData,
        });

        if (response.ok) {
          alert("Property updated!");
          handleClose();
          fetchProperties();
        }
      } catch (error) { console.error("Edit error:", error); }

    } else {
      if (newProperty.images) {
        for (let i = 0; i < newProperty.images.length; i++) {
          formData.append('images', newProperty.images[i]);
        }
      }

      
      try {
        //const response = await fetch('http://localhost:5000/api/properties', {
        const response = await fetch('/api/properties', {
          method: 'POST',
          headers: {
            'Authorization': token,
          },
          body: formData,
        });

        if (response.ok) {
          alert("Success! Property added!");
          handleClose();
          fetchProperties();
        }
      } catch (error) { console.error("Add error:", error); }
    }
  };

  // DELETE & VIEW logic
  const handleDelete = async (prop) => {
    const folderName = getFolderSlug(prop.title); 
    if (window.confirm(`Delete "${prop.title}"?`)) {
      try {
        //const response = await fetch(`http://localhost:5000/api/properties/${prop.state}/${folderName}`, {
        const response = await fetch(`/api/properties/${prop.state}/${folderName}`, {
          method: 'DELETE',
            headers: {
            'Authorization': token,
          },
        });
        if (response.ok) {
          alert("Deleted!");
          fetchProperties();
        }
      } catch (error) { console.error(error); }
    }
  };

  const handleCloseView = () => setShowViewModal(false);
  const handleView = (property) => {
    setSelectedProperty(property);
    setShowViewModal(true);
  };

  //const filteredProperties = properties.filter(p => p.state && p.state.toLowerCase() === activeTab);

  return (
    <div className="admin-dashboard-wrapper">
      <Row className="g-0">
        <Col md={2} className="admin-sidebar d-flex flex-column">
          <div>
            <div className="sidebar-header"><h4>HDPMG Panel</h4></div>
            <Nav className="flex-column mt-4">
              {['arizona', 'florida', 'texas'].map((state) => (
                <Nav.Link 
                  key={state} 
                  className={activeTab === state ? 'active-link' : ''} 
                  onClick={() => setActiveTab(state)}
                >
                  {state.charAt(0).toUpperCase() + state.slice(1)}
                </Nav.Link>
              ))}
            </Nav>
          </div>

          <div className="sidebar-footer p-4">
            <hr className="sidebar-divider" />
            
            <div className="user-info mb-4">
              <span className="sidebar-label">CURRENT USER</span>
              <strong className="admin-email-text d-block">{adminEmail}</strong>
            </div>

            <div className="recent-activity mb-4">
              <span className="sidebar-label">RECENT ACTIVITY</span>
              {recentLogs.length > 0 ? recentLogs.map((log, index) => (
                <div key={index} className="log-entry mb-2 p-2 rounded">
                  <span className="d-block text-truncate log-email" title={log.email}>{log.email}</span>
                  <span className="log-date">
                    {new Date(log.timestamp).toLocaleString('en-US', { month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' })}
                  </span>
                </div>
              )) : <small className="text-muted">No recent logs</small>}
            </div>

            <Nav.Link className="logout-link" href="/">Logout</Nav.Link>
          </div>
        </Col>

        <Col md={10} className="admin-main-content">
          <Container fluid className="p-5">
            <div className="d-flex justify-content-between align-items-center mb-5">
              <h2 className="dashboard-title">Managing: <span className="text-uppercase">{activeTab}</span></h2>
              <Button className="add-btn" onClick={handleShow}>+ Add New Property</Button>
            </div>

            <div className="table-container">
              <Table responsive hover className="admin-table">
                <thead>
                  <tr><th>ID</th><th>Property Title</th><th>Location</th><th>Status</th><th>Actions</th></tr>
                </thead>
                <tbody>
                  {properties && properties.length > 0 ? (
                    properties.map((prop) => (
                      <tr key={prop.id}>
                        <td>#{prop.id.toString().slice(-4)}</td>
                        <td className="fw-bold">{prop.title}</td>
                        <td>{prop.location}</td>

                        <td>
                          <span className={`badge ${prop.isAvailable ? 'bg-success' : 'bg-danger'}`}>
                            {prop.isAvailable ? 'AVAILABLE' : 'LEASED'}
                          </span>
                        </td>
                        
                        <td>
                          <Button variant="outline-info" size="sm" className="me-2" onClick={() => handleView(prop)}>View</Button>
                          <Button variant="outline-primary" size="sm" className="me-2" onClick={() => handleEditOpen(prop)}>Edit</Button>
                          <Button variant="outline-danger" size="sm" onClick={() => handleDelete(prop)}>Delete</Button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="4" className="text-center py-4 text-muted">
                        No properties found in <span className="text-uppercase">{activeTab}</span>.
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </div>
          </Container>
        </Col>
      </Row>

      {/* --- ADD / EDIT MODAL --- */}
      <Modal show={showModal} onHide={handleClose} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>
            {isEditMode ? `Edit Property: ${newProperty.title}` : `Add New Property (${activeTab.toUpperCase()})`}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit}>
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Property Title</Form.Label>
                  <Form.Control type="text" name="title" value={newProperty.title} required onChange={handleChange} />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Location (City, State)</Form.Label>
                  <Form.Control type="text" name="location" value={newProperty.location} required onChange={handleChange} />
                </Form.Group>
              </Col>
            </Row>

            <Form.Group className="mb-3">
              <Form.Label>Google Maps Iframe Link</Form.Label>
              <Form.Control type="text" name="googleMaps" value={newProperty.googleMaps} placeholder="Iframe link" onChange={handleChange} />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Direct Rental Link</Form.Label>
              <Form.Control 
                type="url" 
                name="directLink" 
                value={newProperty.directLink} 
                placeholder="e.g. https://www.zillow.com/..." 
                onChange={handleChange} 
              />
            </Form.Group>
            
            <Form.Group className="mb-3">
              <Form.Check 
                type="switch"
                id="availability-switch"
                label={newProperty.isAvailable ? "Status: AVAILABLE" : "Status: LEASED"}
                checked={newProperty.isAvailable}
                onChange={(e) => setNewProperty({ ...newProperty, isAvailable: e.target.checked })}
                className={newProperty.isAvailable ? "text-success fw-bold" : "text-danger fw-bold"}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Overview</Form.Label>
              <Form.Control as="textarea" rows={3} name="overview" value={newProperty.overview} required onChange={handleChange} />
            </Form.Group>

            {/* AMENITIES */}
            <Form.Group className="mb-3">
              <Form.Label className="fw-bold">Amenities</Form.Label>
              <Row>
                {amenitiesList.map((item, idx) => (
                  <Col xs={6} md={4} key={idx}>
                    <Form.Check 
                      type="checkbox" label={item} 
                      checked={newProperty.amenities.includes(item)}
                      onChange={() => handleCheckboxChange('amenities', item)}
                    />
                  </Col>
                ))}
              </Row>
            </Form.Group>

            {/* AMAZING FEATURES */}
            <Form.Group className="mb-3">
              <Form.Label className="fw-bold text-primary">Amazing Features</Form.Label>
              <Row>
                {amazingFeaturesList.map((feature, idx) => (
                  <Col xs={6} md={4} key={idx}>
                    <Form.Check 
                      type="checkbox" 
                      label={feature} 
                      checked={newProperty.amazingFeatures?.includes(feature)} 
                      onChange={() => handleCheckboxChange('amazingFeatures', feature)}
                    />
                  </Col>
                ))}
              </Row>
            </Form.Group>

            {isEditMode && newProperty.images && (
              <div className="mb-3">
                <Form.Label className="fw-bold">Current Images (Click X to remove)</Form.Label>
                <div className="d-flex gap-2 overflow-auto pb-2">
                  {newProperty.images.map((img, index) => (
                    <div key={index} className="position-relative">
                      <img 
                        //src={`http://localhost:5000/uploads/${img.replace(/\\/g, '/').replace('uploads/', '')}`} 
                        src={`/api/uploads/${img.replace(/\\/g, '/').replace('uploads/', '')}`} 
                        alt="thumb" 
                        style={{ width: '80px', height: '80px', objectFit: 'cover', borderRadius: '5px' }} 
                      />
                      <Button 
                        variant="danger" 
                        size="sm" 
                        className="position-absolute top-0 end-0 py-0 px-1"
                        onClick={() => removeExistingImage(index)}
                      >
                        ×
                      </Button>
                    </div>
                  ))}
                </div>
              </div>
            )}

            <Form.Group className="mb-4">
              <Form.Label>{isEditMode ? "Add More Images" : "Images (20-max)"}</Form.Label>
              <Form.Control 
                type="file" 
                multiple 
                onChange={(e) => {
                  if(isEditMode) {
                    setNewProperty({...newProperty, newImages: e.target.files});
                  } else {
                    setNewProperty({...newProperty, images: e.target.files});
                  }
                }} 
              />
            </Form.Group>

            <div className="d-flex justify-content-end gap-2">
              <Button variant="secondary" onClick={handleClose}>Cancel</Button>
              <Button type="submit" className="add-btn">{isEditMode ? 'Update' : 'Save'}</Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>

      {/* --- Modal for viewing (VIEW) --- */}
      <Modal show={showViewModal} onHide={handleCloseView} size="lg" centered>
        <Modal.Header closeButton className="bg-dark text-white">
          <Modal.Title>Property Preview: {selectedProperty?.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ backgroundColor: '#f8f9fa' }}>
          {selectedProperty && (
            <div className="preview-content p-2">
              <h5 className="mb-3">Gallery</h5>
              <div className="preview-images mb-4 d-flex gap-2 overflow-auto pb-3">
                {selectedProperty.images && selectedProperty.images.length > 0 ? (
                  selectedProperty.images.map((img, index) => {
                    const cleanPath = img.replace(/\\/g, '/').replace('uploads/', '');
                    return (
                      <img 
                        key={index} 
                        //src={`http://localhost:5000/uploads/${cleanPath}`} 
                        src={`/api/uploads/${cleanPath}`} 
                        alt="Property" 
                        style={{ height: '180px', minWidth: '250px', borderRadius: '10px', objectFit: 'cover', border: '1px solid #ddd' }}
                      />
                    );
                  })
                ) : (
                  <div className="p-4 bg-light text-muted border rounded w-100 text-center">No images uploaded.</div>
                )}
              </div>

              <hr />

              <div className="mt-4">
                <a 
                  href={selectedProperty.directLink} 
                  target="_blank" 
                  rel="noreferrer" 
                  className="btn btn-success w-100"
                >
                  <i className="bi bi-house-check"></i> Rental Available (Test Link)
                </a>
              </div>

              <Row className="mt-4">
                <Col md={7}>
                  <div className="mb-4">
                    <h5 className="fw-bold">Overview</h5>
                    <p className="text-muted" style={{ lineHeight: '1.6', whiteSpace: 'pre-line' }}>
                      {selectedProperty.overview}
                    </p>
                  </div>
                  
                  <Row>
                    <Col md={6}>
                      <h6 className="fw-bold text-dark">Amenities</h6>
                      <div className="d-flex flex-wrap gap-1">
                        {selectedProperty.amenities?.length > 0 ? (
                          selectedProperty.amenities.map((a, i) => <span key={i} className="badge bg-secondary">{a}</span>)
                        ) : <small className="text-muted">None</small>}
                      </div>
                    </Col>
                    <Col md={6}>
                      <h6 className="fw-bold text-primary">Amazing Features</h6>
                      <div className="d-flex flex-wrap gap-1">
                        {selectedProperty.amazingFeatures?.length > 0 ? (
                          selectedProperty.amazingFeatures.map((f, i) => <span key={i} className="badge bg-primary">{f}</span>)
                        ) : <small className="text-muted">None</small>}
                      </div>
                    </Col>
                  </Row>
                </Col>

                <Col md={5}>
                  <div className="p-3 bg-white border rounded shadow-sm">
                    <h5 className="fw-bold mb-3 text-dark">Location</h5>
                    <p className="mb-3"><i className="bi bi-geo-alt-fill text-danger"></i> {selectedProperty.location}</p>
                    
                    {/* Check Google Maps */}
                    {selectedProperty.googleMaps && selectedProperty.googleMaps.includes('<iframe') ? (
                      <div className="mt-3 rounded overflow-hidden shadow-sm" 
                        style={{ height: '250px', width: '100%' }}
                        dangerouslySetInnerHTML={{ 
                          __html: selectedProperty.googleMaps
                            .replace(/width="\d+"/, 'width="100%"')
                            .replace(/height="\d+"/, 'height="100%"') 
                        }} 
                      />
                    ) : (
                      <div className="alert alert-warning py-2 small mt-2">
                        <i className="bi bi-exclamation-triangle"></i> Invalid Google Maps code. Please use the "Embed" (iframe) option.
                      </div>
                    )}
                  </div>
                </Col>
              </Row>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer className="bg-light">
          <Button variant="dark" onClick={handleCloseView}>Close Preview</Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default AdminDashboard;